import { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ValuesSection from '../components/Values';

const Values = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header />
      <main className="pt-20">
        <ValuesSection />
      </main>
      <Footer />
    </div>
  );
};

export default Values;
